<template>
  <RichText v-if="Array.isArray(content) == false" :content="content" />
  <div v-else>
    <template v-for="(value, index) in content" :key="index + 'txt'">
      <br v-if="index != 0" />
      <RichText :content="value" />
    </template>
  </div>
</template>
<script>
import { RichText } from "@thegetty-private/getty-ui";

export default {
  name: "RichTextWrapper",
  components: { RichText },
  provide() {
    return {
      /**
       * Options for the markdown renderer used in RichText in DelimitedFieldValues
       */
      delimitedValuesMarkdownOptions: {
        breaks: true
      }
    };
  },
  inheritAttrs: false,
  props: {
    /**
     * The content to display
     */
    content: {
      type: [Object, Array, String],
      default: undefined
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "./index";
</style>
